import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isEnabledForFrontierCopilotAudience, type FrontierFlightConfig, } from "./isEnabledForFrontierCopilotAudience";

const defaultCalendarAgentFrontierFlights: FrontierFlightConfig = {
    publicFlight: "cal-copilot-default-calendar-agent-frontier-public",
    privateTapFlight: "cal-copilot-default-calendar-agent-frontier-private-tap",
    privateStagingFlight: "cal-copilot-default-calendar-agent-frontier-private-staging",
    privateInfluencerFlight: "cal-copilot-default-calendar-agent-frontier-private-influencer",
};

/**
 * Checks if the default calendar agent feature is enabled.
 *
 * Returns true if EITHER:
 * - The global `cal-copilot-default-calendar-agent` flight is on (conventional rollout), OR
 * - The user is a licensed frontier user and the frontier flight for their type is enabled
 */
export function isDefaultCalendarAgentEnabled(mailboxInfo: MailboxInfo): boolean {
    return (isGlobalFeatureEnabled("cal-copilot-default-calendar-agent") ||
        isEnabledForFrontierCopilotAudience(mailboxInfo, defaultCalendarAgentFrontierFlights));
}
